import { render, staticRenderFns } from "./editbenefits.vue?vue&type=template&id=13a3f420&"
import script from "./editbenefits.vue?vue&type=script&lang=js&"
export * from "./editbenefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports